import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './../layout';

import { getContactServiceList, getDeviceAccess, getWishList, partnerApi, vendorDashboard , partnerCategory } from './../../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import {
  Collapse, CardBody, Card, CardHeader, Modal, ModalBody, Row, Col, ModalFooter, ModalHeader
} from 'reactstrap';

import Tabs from "../Tabs";

import TabsPane from "../Tabs/TabsPane";

import DataTable from 'react-data-table-component';

import { MobilePopMenu } from './Common';


import Upgrade from "./subscribe/upgrade";
import Renewal from "./subscribe/renewal";
import Invoice from "./subscribe/invoice";

class partnerSubscriptionInfo extends Component {

  constructor(props) {
    super(props);
    this.state = {
      user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
      authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
    }
 
  }

 showMTab = (element) => {

    $('.submenu-list a').each(function () {
      $(this).removeClass('active');

    });

    $("." + element).addClass("active");
    $(".mainblock").removeClass('active').addClass('hidden');
    $("#" + element).removeClass('hidden').addClass('active');

    //document.getElementById(element).style.display = 'block';
  }

  render() {
    const { current_plan } = this.state.user_data;
    const childTabs = [
      {
        name: "Upgrade",
        id: "upgrade",
        defaultChecked: (current_plan != 0) ? true : false
      },
      {
        name: "Renewal",
        id: "ranewal",
        disabled: true
        // disabled: (current_plan == 0) ? true : false
      },
      {
        name: "Invoice",
        id: "invoice",
        defaultChecked: (current_plan == 0) ? true : false
      },
    ];
 
        return (
            <React.Fragment>
                <AdminLayout>
                    
              <div class="col-12 grid-margin">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Subscription</h4>
                   

                   <Tabs tabsetName="Subscribe" tabClassName="custom-tab" childTabs={childTabs}>
                    <TabsPane id="upgrade">
                      <Upgrade />
                    </TabsPane>
                    <TabsPane id="ranewal">
                      <Renewal />
                    </TabsPane>
                    <TabsPane id="invoice">
                      <Invoice />
                    </TabsPane>
                  </Tabs>

                </div>
              </div>

              
            </div>  


                </AdminLayout>
            </React.Fragment>
        )
    }

}

export default partnerSubscriptionInfo;


// WEBPACK FOOTER //
// ./src/components/bewise/partners/subscriptioninfo.jsx